import { Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { PuckPage } from "src/api/client-api/cms/useCreatePuckPage";
import { PuckRenderer } from "src/components/Puck/PuckRenderer";

type PublicationPreviewDialogProps = {
    preview: PuckPage | null;
    onClose: () => void;
};

export const PublicationPreviewDialog = (props: PublicationPreviewDialogProps) => {
    const { preview, onClose } = props;
    const { t } = useTranslation();

    const previewContent = useMemo(() => {
        try {
            return preview?.content ? JSON.parse(preview.content) : undefined;
        } catch {
            return undefined;
        }
    }, [preview?.content]);

    return (
        <Dialog open={preview !== null} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>
                <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2}>
                    <Typography sx={{ fontSize: 16, fontWeight: 700, lineHeight: 1.6, color: "#393A36" }}>
                        {preview?.title ?? t("publications.preview", "Preview")}
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent dividers>
                {previewContent && <PuckRenderer data={previewContent} isLoading={false} />}
                {!previewContent && (
                    <Typography sx={{ fontSize: 12, fontWeight: 500, lineHeight: 1.6, color: "#767673" }}>
                        {t("publications.preview.empty", "Nothing to preview")}
                    </Typography>
                )}
            </DialogContent>
        </Dialog>
    );
};
